// extracted by css-extract-rspack-plugin
export default {"webcallWrapper":"webcall-wrapper--_Oy9Lu0XSon99e24"};